(function() {
  var DeleteDialog, PlacementStepsKo, ScrollHelper,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ScrollHelper = App.load('core::ScrollHelper');

  DeleteDialog = App.loadClass('core::DeleteDialog');

  PlacementStepsKo = App.loadClass('grower::viewmodels/placement/Steps');

  exports.PlacementHandler = (function(superClass) {
    extend(PlacementHandler, superClass);

    function PlacementHandler() {
      return PlacementHandler.__super__.constructor.apply(this, arguments);
    }

    PlacementHandler.prototype.angular_states = ['grower.placement', 'grower.planting-rx'];

    PlacementHandler.prototype.init = function() {
      var msg;
      this.layoutUrl = 'backend/grower/placement/load-layout';
      this.autofocus = false;
      msg = App.sidebar.messageWriter();
      msg.message_writer();
      msg.message_writer('info', 'Loading...');
      return this.loadLayout();
    };

    PlacementHandler.prototype.afterLoadLayout = function(selector, response) {
      var fs, fsBtn, msg, ref, select, sppID, ths, ufs, ufsBtn;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      msg = App.sidebar.messageWriter();
      msg.message_writer('success', 'Loaded!');
      msg.message_writer('hide');
      ths = this;
      this.spps = response.data.spps;
      select = $(this.layoutSelector).find('#survey_select');
      $(this.layoutSelector).find('#start_survey_button').click((function(_this) {
        return function() {
          var sppID;
          sppID = parseInt(select.val());
          return _this.startSurvey(sppID);
        };
      })(this));
      ufs = $(this.layoutSelector).find('#unfinished_surveys');
      ufsBtn = $(this.layoutSelector).find('#finish_survey_button');
      ScrollHelper.make(ufs, {
        height: 150
      });
      ufs.find('.row-clickable').bind('click', function() {
        return ths.selectSurvey($(this), ufsBtn);
      });
      ufs.find('.delete-btn').bind('click', function() {
        return ths.deleteSurvey($(this));
      });
      ufsBtn.click((function(_this) {
        return function() {
          return _this.finishSurvey();
        };
      })(this));
      fs = $(this.layoutSelector).find('#finished_surveys');
      fsBtn = $(this.layoutSelector).find('#review_survey_button');
      ScrollHelper.make(fs, {
        height: 150
      });
      fs.find('.row-clickable').bind('click', function() {
        return ths.selectSurvey($(this), fsBtn);
      });
      fs.find('.delete-btn').bind('click', function() {
        return ths.deleteSurvey($(this));
      });
      fsBtn.click((function(_this) {
        return function() {
          return _this.reviewSurvey();
        };
      })(this));
      $(this.layoutSelector).find('#placement_report_button').click((function(_this) {
        return function() {
          return $(window).trigger('spp.placement-report');
        };
      })(this));
      $(this.layoutSelector).find('#reset_survey_button').click((function(_this) {
        return function() {
          return _this.resetSurvey();
        };
      })(this)).hide();
      if (!ufs.length && !fs.length && !select.is(':visible')) {
        sppID = parseInt(select.val());
        if (sppID) {
          return this.startSurvey(sppID);
        }
      }
    };

    PlacementHandler.prototype.afterSurveyLoaded = function(spp) {
      var stepList;
      $(this.layoutSelector).find('#reset_survey_button').show();
      stepList = $(this.layoutSelector).find('.spp-step-list');
      this.stepListKO = new PlacementStepsKo(spp);
      ko.applyBindings(this.stepListKO, stepList[0]);
      if (spp.has_multiple_steps) {
        return stepList.show();
      }
    };

    PlacementHandler.prototype.selectSurvey = function(el, btn) {
      var alreadySelected, tr;
      tr = el.closest('tr');
      alreadySelected = tr.hasClass('darken');
      App.sidebar.contentDiv().find('tr').removeClass('darken');
      btn.attr('disabled', 'disabled');
      if (!alreadySelected) {
        tr.addClass('darken');
        btn.removeAttr('disabled');
      }
      return this.setButtonColor(el);
    };

    PlacementHandler.prototype.deleteSurvey = function(el) {
      var del, survey_id, tr;
      tr = el.closest('tr');
      survey_id = tr.attr('data-id');
      del = this.createSubHandler(DeleteDialog, "Delete_Dialog_" + survey_id);
      if (del) {
        del.saveUrl = 'backend/grower/placement/delete-survey';
        del.deleteTitle = 'Survey';
        del.deleteMessage = 'this Survey';
        del.deleteItemID = survey_id;
        del.delayAfterSuccess = true;
        del.override_savingText = true;
        del.savingText = 'Deleting...';
        del.savedText = 'Deleted';
        del.init();
        return del.successAction = function() {
          return App.current_page.refresh();
        };
      }
    };

    PlacementHandler.prototype.finishSurvey = function() {
      var resultID, sppID, tr;
      tr = $(this.layoutSelector).find('#unfinished_surveys tr.darken').first();
      if (!tr.length) {
        return;
      }
      resultID = parseInt(tr.attr('data-id'));
      sppID = parseInt(tr.attr('data-pp-id'));
      return this.startSurvey(sppID, resultID);
    };

    PlacementHandler.prototype.reviewSurvey = function() {
      var resultID, sppID, tr;
      tr = $(this.layoutSelector).find('#finished_surveys tr.darken').first();
      if (!tr.length) {
        return;
      }
      resultID = parseInt(tr.attr('data-id'));
      sppID = parseInt(tr.attr('data-pp-id'));
      return this.startSurvey(sppID, resultID);
    };

    PlacementHandler.prototype.startSurvey = function(spp_id, result_id) {
      var handler_name, ref, spp, spp_name;
      if (result_id == null) {
        result_id = null;
      }
      if (!this.spps.length) {
        throw new Error('No SPPs were loaded');
      }
      spp_name = (ref = _.filter(this.spps, {
        id: spp_id
      })[0]) != null ? ref.internal_name : void 0;
      if (!spp_name) {
        throw new Error('The selected SPP was not found');
      }
      handler_name = spp_name.replace(/_/g, '') + 'Handler';
      spp = this.createSubHandler("grower::handlers/placement/spps/" + handler_name);
      if (spp) {
        spp.sppID = spp_id;
        spp.resultID = result_id != null ? result_id : null;
        spp.init();
        return $(this.layoutSelector).find('#start_survey_area').hide();
      } else {
        throw new Error(spp_name + " is not a valid placement program name");
      }
    };

    PlacementHandler.prototype.resetSurvey = function() {
      return App.current_page.refresh();
    };

    PlacementHandler.prototype.setButtonColor = function(el) {
      var div, finishButton, finishedTable, reviewButton, startButton, unfinishedTable;
      div = el.closest('div#start_survey_area');
      unfinishedTable = div.find('table#unfinished_surveys');
      finishedTable = div.find('table#finished_surveys');
      finishButton = div.find('#finish_survey_button');
      reviewButton = div.find('#review_survey_button');
      startButton = div.find('#start_survey_button');
      if (unfinishedTable.find('tr.darken').length) {
        finishButton.addClass('btn-primary');
        startButton.removeClass('btn-primary');
      } else {
        finishButton.removeClass('btn-primary');
        if (finishedTable.find('tr.darken').length) {
          startButton.removeClass('btn-primary');
        } else {
          startButton.addClass('btn-primary');
        }
      }
      if (finishedTable.find('tr.darken').length) {
        return reviewButton.addClass('btn-primary');
      } else {
        return reviewButton.removeClass('btn-primary');
      }
    };

    return PlacementHandler;

  })(Handler);

}).call(this);
